﻿/**
 * Smooth switch between content and empty.
 * Wraps content in a div with display: grid.
 *
 * Display children if on is true.
 */

import React, { useEffect, useRef, useState } from 'react';

export const Appear = ({
    id,
    labelledBy,
    children,
    direction = 'vertical',
    on,
    className,
}) => {
    const appearTimeout = useRef(null);
    const [transitioning, setTransitioning] = useState(false);

    useEffect(() => {
        if (appearTimeout.current) {
            clearTimeout(appearTimeout.current);
            setTransitioning(false);
        }

        setTransitioning(true);

        appearTimeout.current = setTimeout(() => {
            clearTimeout(appearTimeout.current);
            appearTimeout.current = null;
            setTransitioning(false);
        }, 600);

        return () => {
            if (appearTimeout.current) {
                clearTimeout(appearTimeout.current);
            }
        };
    }, [on, setTransitioning]);

    return (
        <div
            id={id}
            aria-labelledby={labelledBy}
            aria-hidden={!on}
            className={[
                'appearutil',
                on ? 'appearutil--on' : '',
                transitioning ? 'appearutil--transitioning': '',
                `appearutil--direction-${direction}`,
                className || ''
            ].join(' ')
            }
        >
            <div className={'appearutil__content'}>{children}</div>
        </div>
    );
};